import Form from "react-bootstrap/Form";
import { CONTACT_BLOCK_REASON } from "lookup/ContactBlockConstants";

const ContactBlockAlert = ({
  fieldName,
  value,
  reason,
  message,
  previouslyWrongSuffix,
  unmarkLabel,
  showUnmark,
  acknowledged,
  onAcknowledgeChange,
}) => {
  const isBlacklisted = reason === CONTACT_BLOCK_REASON.BLACKLISTED;

  return (
    <div
      className={`field-contact-block ${
        isBlacklisted ? "field-contact-block-blacklist" : ""
      }`}
      data-testid={`contact-block-alert-${fieldName}`}
    >
      {isBlacklisted ? (
        <div>{message}</div>
      ) : (
        <div>
          <code>{value}</code>
          {previouslyWrongSuffix}
        </div>
      )}
      {showUnmark && !isBlacklisted && (
        <Form.Check
          className="mt-2 mb-0"
          type="checkbox"
          id={`unmark-${fieldName}`}
          checked={!!acknowledged}
          onChange={(e) => onAcknowledgeChange(e.target.checked)}
          label={unmarkLabel}
          data-testid={`unmark-checkbox-${fieldName}`}
        />
      )}
    </div>
  );
};

export default ContactBlockAlert;
